import { render } from "./WorkspaceDocumentTree.vue?vue&type=template&id=c70e3d56&scoped=true&ts=true"
import script from "./WorkspaceDocumentTree.vue?vue&type=script&lang=ts"
export * from "./WorkspaceDocumentTree.vue?vue&type=script&lang=ts"

import "./WorkspaceDocumentTree.vue?vue&type=style&index=0&id=c70e3d56&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c70e3d56"]])

export default __exports__